export var BN_ROUNDING;
(function(BN_ROUNDING) {
    BN_ROUNDING[BN_ROUNDING["DEFAULT"] = 4] = "DEFAULT";
    BN_ROUNDING[BN_ROUNDING["UP"] = 0] = "UP";
    BN_ROUNDING[BN_ROUNDING["DOWN"] = 1] = "DOWN";
    BN_ROUNDING[BN_ROUNDING["CEIL"] = 2] = "CEIL";
    BN_ROUNDING[BN_ROUNDING["FLOOR"] = 3] = "FLOOR";
    BN_ROUNDING[BN_ROUNDING["HALF_UP"] = 4] = "HALF_UP";
    BN_ROUNDING[BN_ROUNDING["HALF_DOWN"] = 5] = "HALF_DOWN";
    BN_ROUNDING[BN_ROUNDING["HALF_CEIL"] = 7] = "HALF_CEIL";
    BN_ROUNDING[BN_ROUNDING["HALF_FLOOR"] = 8] = "HALF_FLOOR";
})(BN_ROUNDING || (BN_ROUNDING = {}));
export var BN_ASSERT_DECIMALS_OP;
(function(BN_ASSERT_DECIMALS_OP) {
    BN_ASSERT_DECIMALS_OP["LESS"] = "LESS";
    BN_ASSERT_DECIMALS_OP["GREATER"] = "GREATER";
})(BN_ASSERT_DECIMALS_OP || (BN_ASSERT_DECIMALS_OP = {}));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnVtcy9ibi50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBCTl9ST1VORElORyB7XG4gIERFRkFVTFQgPSA0LFxuICBVUCA9IDAsXG4gIERPV04gPSAxLFxuICBDRUlMID0gMixcbiAgRkxPT1IgPSAzLFxuICBIQUxGX1VQID0gNCxcbiAgSEFMRl9ET1dOID0gNSxcbiAgSEFMRl9DRUlMID0gNyxcbiAgSEFMRl9GTE9PUiA9IDgsXG59XG5cbmV4cG9ydCBlbnVtIEJOX0FTU0VSVF9ERUNJTUFMU19PUCB7XG4gIExFU1MgPSAnTEVTUycsXG4gIEdSRUFURVIgPSAnR1JFQVRFUicsXG59XG4iXSwibmFtZXMiOlsiQk5fUk9VTkRJTkciLCJCTl9BU1NFUlRfREVDSU1BTFNfT1AiXSwicmFuZ2VNYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OzsiLCJtYXBwaW5ncyI6IjtVQUFZQTs7Ozs7Ozs7OztHQUFBQSxnQkFBQUE7O1VBWUFDOzs7R0FBQUEsMEJBQUFBIn0=